import { render, staticRenderFns } from "./TaxationLadderEditor.vue?vue&type=template&id=1c265a98&scoped=true&"
import script from "./TaxationLadderEditor.vue?vue&type=script&lang=js&"
export * from "./TaxationLadderEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c265a98",
  null
  
)

export default component.exports